import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/development/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { DevelopmentFeature } from '@framework/workbench/ui/development/development-feature';
import { isLocalDebug, isTestEnvId } from '@src/js/common/utils';

@Controller({ menuItems: MENU_CONFIGS })
export class DevelopmentController {
    constructor(private readonly feature: DevelopmentFeature) {
    }

    @Menu(ActionType.PERFORMANCE, 'onClick')
    public handleClickPerformance() {
        this.feature.showPerformance();
    }

    @Menu(ActionType.DEVELOPMENT, 'shouldHide')
    public hidePerformance() {
        return !isLocalDebug() && !isTestEnvId();
    }
}
